export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
// Import Swiper.js
// import Swiper from 'swiper';
import { Swiper, Navigation, Pagination, Scrollbar, EffectCoverflow } from 'swiper/swiper.esm';
Swiper.use([Navigation, Pagination, Scrollbar, EffectCoverflow]);

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookSquare, faInstagram, faLinkedin, faGoogleDrive } from '@fortawesome/free-brands-svg-icons';
// import the Envelope icons
import { faEnvelope, faAddressBook, faCheck, faCheckSquare, faOtter, faBars, faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faSeedling, faHiking, faUser, faFilePdf } from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(faFacebookSquare, faInstagram, faLinkedin, faEnvelope, faCheck, faAddressBook, faCheckSquare, faOtter, faBars, faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faSeedling, faHiking, faUser, faGoogleDrive, faFilePdf );

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

jQuery(function($) {
  $(document).ready(function () {

    var $slider = $('.block-species--contentxxxx');

    var $progressBarLabel = $( '.slider__labelxxxxx' );


    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var $blockID = $(this).parent().attr('id');
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      var $progressBar = $( '#' + $blockID + ' .progress');

      $progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc );

      $progressBarLabel.text( calc + '% completed' );

    });

    $slider.slick({
      arrowsPlacement: 'afterSlides',
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      // dots:true,
      variableWidth: true,
      centerMode: false,
      swipe: true,
      mobileFirst:true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          // centerMode: true,
        },
      }, {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // dots: true,
          infinite: true,
        },
      },  {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // dots: true,
          infinite: true,
        },
      }],
    });

    // var $accordion_container = $('.schema-faq');
    // var $accordion_item = $('.schema-faq-section');
    // var $accordion_content = $('.schema-faq-answer');
    // var $accordion_title = $('.schema-faq-question');
    // var $accordion_title_content = $('.schema-faq-question').contents();

    // $accordion_container.find('.schema-faq-question').unwrap().wrap('<a href="#" class="accordion-title"/>');

    // $accordion_title.replaceWith($('<a href="#faq">' + $accordion_title_content + '</a>'));

    // $('.schema-faq-question').replaceTag('<span>', true);

    // $accordion_container.attr({
    //   'data-accordion':'',
    //   'data-multi-expand':'true',
    //   'role':'tablist',
    //   'id':'faqs',
    // });
    // $accordion_container.addClass('accordion');
    // $accordion_item.attr('data-accordion-item','');
    // $accordion_item.addClass('accordion-item');
    // $accordion_content.attr('data-tab-content','');
    // $accordion_content.addClass('accordion-content');

    /* eslint-disable */
    // var mySwiper = new Swiper('.swiper-container', {
    //   slidesPerView: 4,
    //   spaceBetween: 30,
    //   centeredSlides: true,
    //   pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    //   },
    // });

    var swiper = new Swiper('.swiper-container', {
      // Optional parameters
      // direction: 'vertical',
      // loop: true,
      slidesPerView: 2,
      spaceBetween: 30,

      // If we need pagination
      // pagination: {
      //   el: '.swiper-pagination',
      // },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.c-slider-nav__btn--next',
        prevEl: '.c-slider-nav__btn--prev',
        disabledClass: 'disabled_swiper_button',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.progress',
      },

      breakpoints: {
        560: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });



    $('.cat-list--item').on('click', function() {
      $('.cat-list--item').removeClass('active');
      $(this).addClass('active');

      $.ajax({
        type: 'POST',
        url: '/wp/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
          action: 'filter_posts',
          category: $(this).data('slug'),
        },
        success: function(res) {
          $('.project-tiles').html(res);
        }
      })
    });
    /* eslint-enable */
  });

});



// WEBPACK FOOTER //
// ./scripts/routes/common.js